// MST
import { types, flow, cast } from 'mobx-state-tree'

// Interfaces
import { IDocumentDetailDropdown } from 'interfaces/back-office/master/document-detail'
import { IDocumentDetailGetDropdownAttrs } from 'interfaces/back-office/master/document-detail/document-detail-view.interface'
import { IDocumentDetailApiGetDropdownResponse } from 'interfaces/back-office/master/document-detail/document-detail-api.interface'

// Extensions
import { withHelper_baseResponseDropdownTypesModel } from 'models/extensions/with-helper'
import { withEnvironment } from 'models/extensions/with-environment'

// Base Model
const DocumentDetailStoreModal = types
  .model('DocumentDetail')
  .props({
    masterDocumentDetail_isLoading: types.optional(types.boolean, false),
    masterDocumentDetail_dropdown: withHelper_baseResponseDropdownTypesModel('DocumentDetailDropdown'),
  })
  .extend(withEnvironment)
  .actions(self => ({
    masterDocumentDetail_SET_LOADING: (payload: boolean): void => {
      self.masterDocumentDetail_isLoading = payload
    },
    masterDocumentDetail_SET_DOCUMENT_DETAIL_DROPDOWN: (payload: IDocumentDetailDropdown[]): void => {
      self.masterDocumentDetail_dropdown = cast(payload.filter(dropdown => dropdown.value))
    },
    masterDocumentDetail_CLEAR_DOCUMENT_DETAIL_DROPDOWN: (): void => {
      self.masterDocumentDetail_dropdown = cast([])
    },
  }))
  .actions(self => ({
    /**
     * @description Fetch document detail dropdown
     *
     * @param {IDocumentDetailGetDropdownAttrs} payload
     *
     * @return {any} any
     */
    masterDocumentDetail_fetchDocumentDetailDropdown: flow(function* (payload: IDocumentDetailGetDropdownAttrs) {
      self.masterDocumentDetail_SET_LOADING(true)

      const response: IDocumentDetailApiGetDropdownResponse =
        yield self.environment.masterDocumentDetailApi.documentDetail_getDocumentDetailDropdown({
          requestConfig: { ...payload.requestConfig },
        })
      if (response.ok) {
        self.masterDocumentDetail_SET_DOCUMENT_DETAIL_DROPDOWN(response.res.data || [])

        // Do when response success
        if (payload?.onSuccess) payload.onSuccess()
      }

      if (!response.ok) {
        // Do when response error
        if (payload?.onError) payload.onError()
      }

      self.masterDocumentDetail_SET_LOADING(false)
    }),
  }))

export const createDocumentDetailStoreDefaultModel = () => types.optional(DocumentDetailStoreModal, {})
